import { render } from "./NotesInfo.vue?vue&type=template&id=b9887ba0&scoped=true"
import script from "./NotesInfo.vue?vue&type=script&lang=js"
export * from "./NotesInfo.vue?vue&type=script&lang=js"

import "./NotesInfo.vue?vue&type=style&index=0&id=b9887ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9887ba0"]])

export default __exports__